import { IACError } from './iacError';
import { TYPES } from './constants';
import { IACUsecase } from './iacType/iacUsecase';
import { IACTracking } from './addon/iacTracking';
import { FullScreenApplication, DialogApplication } from './application';
import { Navigator, IACCommunication, IACEndpoint } from '.';
import * as Logger from '@navigator/frontend-logger';

/*
 * This is the dispatcher for all IAC messages.
 * Some of the code should be more decoupled.
 */
export class IACHub {

  public static handle(usecase: IACUsecase): void {
    // SAK: this dependency is not necessary I guess
    if (!(usecase instanceof IACUsecase)) {
      throw new IACError('IACHub can only handle type IACUsecase messages.');
    }

    const sender = Navigator.getApplication(usecase.getSender());
    let sysname;
    let receivers;
    let isBroadcast = false;

    if (usecase.config.apps.length === 1 && usecase.config.apps[0] === 'broadcast') {
      isBroadcast = true;
      // This is a broadcast. The Navigator will receive this use case as well.
      // SAK: should be decoupled
      try {
        IACEndpoint.dispatch(usecase);
      } catch (e) {
        Logger.error(`Could not dispatch broadcast ${usecase.getName()} from sender ${usecase.getSender()}` +
          ` to navigator with payload '${usecase.getPayload()}' and previous error message: ${e.message || ''}`);
      }

      // Every other running application will receive this use case.
      receivers = Navigator.getApplications('*', (app) => app.isRunning());

    } else {
      // Just the configured apps will receive this configured use case.
      receivers = Navigator.getApplications(usecase.config.apps);
    }

    IACTracking.track(usecase);

    receivers.forEach((receiverApp): any => {
      sysname = receiverApp.getSysname();

      // The Navigator differs.
      if (sysname === IACEndpoint.SYSNAME) {
        try {
          IACEndpoint.dispatch(usecase);
        } catch (e) {
          Logger.error(`Could not dispatch usecase ${usecase.getName()} from sender ${usecase.getSender()}` +
            ` to navigator with payload '${usecase.getPayload()}' and previous error message: ${e.message || ''}`);
        }
        return true;
      }

      const application = Navigator.getApplication(sysname);

      if (application instanceof FullScreenApplication) {
        switch (true) {

          case !!(usecase.protocol.getFlags() & TYPES.RPC):
            // Let's start and focus the application
            Navigator.openApplication(sysname, false);

            // hide navigator if app type is defined as splash screen
            if ((usecase.protocol.getFlags() & TYPES.SPLASH) === TYPES.SPLASH) {
              Navigator.hide();
            } else {
              Navigator.show();
            }

            break;

          case !!(usecase.protocol.getFlags() & TYPES.RPE):
            /* istanbul ignore next else */
            if (!isBroadcast) {
              // Let's start the app.
              // The app will be started silent, without to be focused.
              Navigator.openApplication(sysname, true);
            }
            break;

          /* istanbul ignore next */
          default:
            break;
        }

      } else /* istanbul ignore next else */ if (application instanceof DialogApplication) {
        if (!isBroadcast) {
          // Open a dialog app. The dialog needs the opener application.
          Navigator.openDialog(sender, sysname);
        }
      }

      IACCommunication.sendMessage(usecase, application);
    });
  }
}
